var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "custom-box",
        {
          attrs: {
            title: _vm.$t("add"),
            visible: _vm.dialogShow,
            modal: false,
            "close-on-click-modal": false,
            "modal-append-to-body": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogShow = $event
            },
            close: function($event) {
              return _vm.clearData(true)
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "popover",
              attrs: {
                "label-position": "left",
                rules: _vm.rules,
                model: _vm.paramsData,
                "label-width": "120px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  staticStyle: { width: "100%" },
                  attrs: { prop: "role_id", label: _vm.$t("whitelistAccount") }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "flex-1",
                      attrs: {
                        prop: "label",
                        filterable: "",
                        placeholder: _vm.$t("pleaseChoose")
                      },
                      on: { change: _vm.roleChange },
                      model: {
                        value: _vm.paramsData.role_id,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "role_id", $$v)
                        },
                        expression: "paramsData.role_id"
                      }
                    },
                    _vm._l(_vm.gmWelfareWhiteListsList, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: {
                          label: _vm.$t("roleIdDeviceIdLabel", {
                            roleId: item.user_id,
                            deviceId: item.device_id
                          }),
                          value: item.user_id
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: {
                    prop: "amount",
                    label: _vm.$t("rechargeAmountCents")
                  }
                },
                [
                  _c("el-input", {
                    staticClass: "flex-1 no-number",
                    attrs: {
                      type: "number",
                      placeholder: _vm.$t("pleaseInputRechargeAmount")
                    },
                    model: {
                      value: _vm.paramsData.amount,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "amount", _vm._n($$v))
                      },
                      expression: "paramsData.amount"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "pay_id", label: _vm.$t("rechargeItemId") }
                },
                [
                  _c("el-input", {
                    staticClass: "flex-1 no-number",
                    attrs: { placeholder: _vm.$t("pleaseInputRechargeItemId") },
                    model: {
                      value: _vm.paramsData.pay_id,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "pay_id", $$v)
                      },
                      expression: "paramsData.pay_id"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { round: "" },
                  on: {
                    click: function($event) {
                      _vm.dialogShow = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "warning", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.clearData()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("reset")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", round: "" },
                  on: { click: _vm.dataFormSubmit }
                },
                [_vm._v(_vm._s(_vm.$t("submit")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }